module.exports = __webpack_public_path__ + "img/456644fcc684eecb7f96f54a2e87af63.png";